// source: billing.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_api_annotations_pb = require('./google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_type_money_pb = require('./google/type/money_pb.js');
goog.object.extend(proto, google_type_money_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.BillingHold', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEventType', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.BillingHoldChildState', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.BillingHoldState', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.BillingTransaction', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.RelatedEntityCase', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.SubscriptionTier', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.SpecificMetadataCase', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.TransactionType', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.displayName = 'proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.displayName = 'proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.billing.BillingHold.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.BillingHold, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.BillingHold.displayName = 'proto.org.codetricks.construction.code.assistant.billing.BillingHold';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.displayName = 'proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.displayName = 'proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.oneofGroups_);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.BillingTransaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.displayName = 'proto.org.codetricks.construction.code.assistant.billing.BillingTransaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.oneofGroups_);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.displayName = 'proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.displayName = 'proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.displayName = 'proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest.displayName = 'proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.displayName = 'proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.displayName = 'proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.displayName = 'proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.displayName = 'proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.displayName = 'proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.displayName = 'proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.displayName = 'proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.displayName = 'proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.displayName = 'proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.displayName = 'proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.displayName = 'proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.displayName = 'proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.displayName = 'proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.displayName = 'proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.displayName = 'proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.displayName = 'proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.displayName = 'proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.displayName = 'proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.displayName = 'proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.displayName = 'proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
userEmail: jspb.Message.getFieldWithDefault(msg, 1, ""),
availableBalance: (f = msg.getAvailableBalance()) && google_type_money_pb.Money.toObject(includeInstance, f),
subscriptionTier: jspb.Message.getFieldWithDefault(msg, 3, 0),
complimentaryCredits: (f = msg.getComplimentaryCredits()) && google_type_money_pb.Money.toObject(includeInstance, f),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
stripeCustomerId: jspb.Message.getFieldWithDefault(msg, 7, ""),
usageStats: (f = msg.getUsageStats()) && proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.toObject(includeInstance, f),
heldBalance: (f = msg.getHeldBalance()) && google_type_money_pb.Money.toObject(includeInstance, f),
ledgerBalance: (f = msg.getLedgerBalance()) && google_type_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile;
  return proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 2:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setAvailableBalance(value);
      break;
    case 3:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.billing.SubscriptionTier} */ (reader.readEnum());
      msg.setSubscriptionTier(value);
      break;
    case 4:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setComplimentaryCredits(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStripeCustomerId(value);
      break;
    case 8:
      var value = new proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.deserializeBinaryFromReader);
      msg.setUsageStats(value);
      break;
    case 9:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setHeldBalance(value);
      break;
    case 10:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setLedgerBalance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAvailableBalance();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionTier();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getComplimentaryCredits();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStripeCustomerId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUsageStats();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.serializeBinaryToWriter
    );
  }
  f = message.getHeldBalance();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getLedgerBalance();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_email = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.type.Money available_balance = 2;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.getAvailableBalance = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 2));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.setAvailableBalance = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.clearAvailableBalance = function() {
  return this.setAvailableBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.hasAvailableBalance = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SubscriptionTier subscription_tier = 3;
 * @return {!proto.org.codetricks.construction.code.assistant.billing.SubscriptionTier}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.getSubscriptionTier = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.billing.SubscriptionTier} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.SubscriptionTier} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.setSubscriptionTier = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.type.Money complimentary_credits = 4;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.getComplimentaryCredits = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 4));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.setComplimentaryCredits = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.clearComplimentaryCredits = function() {
  return this.setComplimentaryCredits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.hasComplimentaryCredits = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string stripe_customer_id = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.getStripeCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.setStripeCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional BillingUsageStats usage_stats = 8;
 * @return {?proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.getUsageStats = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats, 8));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.setUsageStats = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.clearUsageStats = function() {
  return this.setUsageStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.hasUsageStats = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.type.Money held_balance = 9;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.getHeldBalance = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 9));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.setHeldBalance = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.clearHeldBalance = function() {
  return this.setHeldBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.hasHeldBalance = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.type.Money ledger_balance = 10;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.getLedgerBalance = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 10));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.setLedgerBalance = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.clearLedgerBalance = function() {
  return this.setLedgerBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.prototype.hasLedgerBalance = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
childKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
state: jspb.Message.getFieldWithDefault(msg, 3, 0),
actualAmount: (f = msg.getActualAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
terminalAt: (f = msg.getTerminalAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
terminalReason: jspb.Message.getFieldWithDefault(msg, 6, ""),
registeredAt: (f = msg.getRegisteredAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild;
  return proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChildKey(value);
      break;
    case 3:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChildState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 4:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setActualAmount(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTerminalAt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTerminalReason(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRegisteredAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChildKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getActualAmount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getTerminalAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTerminalReason();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRegisteredAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string child_key = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.getChildKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.setChildKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional BillingHoldChildState state = 3;
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChildState}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.getState = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChildState} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChildState} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.type.Money actual_amount = 4;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.getActualAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 4));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.setActualAmount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.clearActualAmount = function() {
  return this.setActualAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.hasActualAmount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp terminal_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.getTerminalAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.setTerminalAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.clearTerminalAt = function() {
  return this.setTerminalAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.hasTerminalAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string terminal_reason = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.getTerminalReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.setTerminalReason = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp registered_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.getRegisteredAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.setRegisteredAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.clearRegisteredAt = function() {
  return this.setRegisteredAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.prototype.hasRegisteredAt = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.repeatedFields_ = [17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.BillingHold.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userEmail: jspb.Message.getFieldWithDefault(msg, 2, ""),
taskType: jspb.Message.getFieldWithDefault(msg, 3, ""),
amount: (f = msg.getAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
state: jspb.Message.getFieldWithDefault(msg, 5, 0),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
expiresAt: (f = msg.getExpiresAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
closedAt: (f = msg.getClosedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
actualAmount: (f = msg.getActualAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
capturedAmount: (f = msg.getCapturedAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
unbilledAmount: (f = msg.getUnbilledAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
closeReason: jspb.Message.getFieldWithDefault(msg, 12, ""),
projectId: jspb.Message.getFieldWithDefault(msg, 13, ""),
holdId: jspb.Message.getFieldWithDefault(msg, 14, ""),
operationId: jspb.Message.getFieldWithDefault(msg, 15, ""),
expectedChildCount: jspb.Message.getFieldWithDefault(msg, 16, 0),
childrenList: jspb.Message.toObjectList(msg.getChildrenList(),
    proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.toObject, includeInstance),
settlementStartedAt: (f = msg.getSettlementStartedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
distributedSettlement: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
terminalCount: jspb.Message.getFieldWithDefault(msg, 20, 0),
actualAmountNanosTotal: jspb.Message.getFieldWithDefault(msg, 21, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.BillingHold;
  return proto.org.codetricks.construction.code.assistant.billing.BillingHold.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskType(value);
      break;
    case 4:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 5:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpiresAt(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setClosedAt(value);
      break;
    case 9:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setActualAmount(value);
      break;
    case 10:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setCapturedAmount(value);
      break;
    case 11:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setUnbilledAmount(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCloseReason(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperationId(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpectedChildCount(value);
      break;
    case 17:
      var value = new proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.deserializeBinaryFromReader);
      msg.addChildren(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSettlementStartedAt(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDistributedSettlement(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTerminalCount(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setActualAmountNanosTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.BillingHold.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTaskType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getExpiresAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getClosedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getActualAmount();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getCapturedAmount();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getUnbilledAmount();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getCloseReason();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getHoldId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getOperationId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getExpectedChildCount();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild.serializeBinaryToWriter
    );
  }
  f = message.getSettlementStartedAt();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDistributedSettlement();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getTerminalCount();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getActualAmountNanosTotal();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_email = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string task_type = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getTaskType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setTaskType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.type.Money amount = 4;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 4));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional BillingHoldState state = 5;
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getState = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp expires_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getExpiresAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setExpiresAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.clearExpiresAt = function() {
  return this.setExpiresAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.hasExpiresAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp closed_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getClosedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setClosedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.clearClosedAt = function() {
  return this.setClosedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.hasClosedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.type.Money actual_amount = 9;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getActualAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 9));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setActualAmount = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.clearActualAmount = function() {
  return this.setActualAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.hasActualAmount = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.type.Money captured_amount = 10;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getCapturedAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 10));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setCapturedAmount = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.clearCapturedAmount = function() {
  return this.setCapturedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.hasCapturedAmount = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.type.Money unbilled_amount = 11;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getUnbilledAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 11));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setUnbilledAmount = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.clearUnbilledAmount = function() {
  return this.setUnbilledAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.hasUnbilledAmount = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string close_reason = 12;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getCloseReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setCloseReason = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string project_id = 13;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string hold_id = 14;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getHoldId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setHoldId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string operation_id = 15;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getOperationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setOperationId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional int32 expected_child_count = 16;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getExpectedChildCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setExpectedChildCount = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * repeated BillingHoldChild children = 17;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild>}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getChildrenList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild, 17));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild>} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setChildrenList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.addChildren = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.org.codetricks.construction.code.assistant.billing.BillingHoldChild, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.clearChildrenList = function() {
  return this.setChildrenList([]);
};


/**
 * optional google.protobuf.Timestamp settlement_started_at = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getSettlementStartedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setSettlementStartedAt = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.clearSettlementStartedAt = function() {
  return this.setSettlementStartedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.hasSettlementStartedAt = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional bool distributed_settlement = 19;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getDistributedSettlement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setDistributedSettlement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional int64 terminal_count = 20;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getTerminalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setTerminalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 actual_amount_nanos_total = 21;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.getActualAmountNanosTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHold} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHold.prototype.setActualAmountNanosTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
eventId: jspb.Message.getFieldWithDefault(msg, 1, ""),
holdId: jspb.Message.getFieldWithDefault(msg, 2, ""),
operationId: jspb.Message.getFieldWithDefault(msg, 3, ""),
taskId: jspb.Message.getFieldWithDefault(msg, 4, ""),
childKey: jspb.Message.getFieldWithDefault(msg, 5, ""),
userEmail: jspb.Message.getFieldWithDefault(msg, 6, ""),
eventType: jspb.Message.getFieldWithDefault(msg, 7, 0),
fromState: jspb.Message.getFieldWithDefault(msg, 8, 0),
toState: jspb.Message.getFieldWithDefault(msg, 9, 0),
authorizedAmount: (f = msg.getAuthorizedAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
actualAmount: (f = msg.getActualAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
capturedAmount: (f = msg.getCapturedAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
releasedAmount: (f = msg.getReleasedAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
reason: jspb.Message.getFieldWithDefault(msg, 14, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
projectId: jspb.Message.getFieldWithDefault(msg, 16, ""),
taskType: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent;
  return proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperationId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setChildKey(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 7:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEventType} */ (reader.readEnum());
      msg.setEventType(value);
      break;
    case 8:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState} */ (reader.readEnum());
      msg.setFromState(value);
      break;
    case 9:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState} */ (reader.readEnum());
      msg.setToState(value);
      break;
    case 10:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setAuthorizedAmount(value);
      break;
    case 11:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setActualAmount(value);
      break;
    case 12:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setCapturedAmount(value);
      break;
    case 13:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setReleasedAmount(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHoldId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOperationId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getChildKey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEventType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getFromState();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getToState();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getAuthorizedAmount();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getActualAmount();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getCapturedAmount();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getReleasedAmount();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getTaskType();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * optional string event_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string hold_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getHoldId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setHoldId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string operation_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getOperationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setOperationId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string task_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string child_key = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getChildKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setChildKey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string user_email = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional BillingHoldAuditEventType event_type = 7;
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEventType}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getEventType = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEventType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEventType} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setEventType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional BillingHoldState from_state = 8;
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getFromState = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setFromState = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional BillingHoldState to_state = 9;
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getToState = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setToState = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional google.type.Money authorized_amount = 10;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getAuthorizedAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 10));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setAuthorizedAmount = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.clearAuthorizedAmount = function() {
  return this.setAuthorizedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.hasAuthorizedAmount = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.type.Money actual_amount = 11;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getActualAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 11));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setActualAmount = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.clearActualAmount = function() {
  return this.setActualAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.hasActualAmount = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.type.Money captured_amount = 12;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getCapturedAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 12));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setCapturedAmount = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.clearCapturedAmount = function() {
  return this.setCapturedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.hasCapturedAmount = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.type.Money released_amount = 13;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getReleasedAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 13));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setReleasedAmount = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.clearReleasedAmount = function() {
  return this.setReleasedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.hasReleasedAmount = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string reason = 14;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string project_id = 16;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string task_type = 17;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.getTaskType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEvent.prototype.setTaskType = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.toObject = function(includeInstance, msg) {
  var f, obj = {
totalSpent: (f = msg.getTotalSpent()) && google_type_money_pb.Money.toObject(includeInstance, f),
totalTasksExecuted: jspb.Message.getFieldWithDefault(msg, 2, 0),
lastTaskDate: (f = msg.getLastTaskDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
monthlySpend: (f = msg.getMonthlySpend()) && google_type_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats;
  return proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalSpent(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalTasksExecuted(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastTaskDate(value);
      break;
    case 4:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setMonthlySpend(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalSpent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getTotalTasksExecuted();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLastTaskDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMonthlySpend();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.type.Money total_spent = 1;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.getTotalSpent = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 1));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.setTotalSpent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.clearTotalSpent = function() {
  return this.setTotalSpent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.hasTotalSpent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 total_tasks_executed = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.getTotalTasksExecuted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.setTotalTasksExecuted = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp last_task_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.getLastTaskDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.setLastTaskDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.clearLastTaskDate = function() {
  return this.setLastTaskDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.hasLastTaskDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.type.Money monthly_spend = 4;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.getMonthlySpend = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 4));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.setMonthlySpend = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.clearMonthlySpend = function() {
  return this.setMonthlySpend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingUsageStats.prototype.hasMonthlySpend = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.oneofGroups_ = [[9,10]];

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.RelatedEntityCase = {
  RELATED_ENTITY_NOT_SET: 0,
  TASK_ID: 9,
  STRIPE_PAYMENT_INTENT_ID: 10
};

/**
 * @return {proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.RelatedEntityCase}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.getRelatedEntityCase = function() {
  return /** @type {proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.RelatedEntityCase} */(jspb.Message.computeOneofCase(this, proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.toObject = function(includeInstance, msg) {
  var f, obj = {
transactionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userEmail: jspb.Message.getFieldWithDefault(msg, 2, ""),
type: jspb.Message.getFieldWithDefault(msg, 3, 0),
amount: (f = msg.getAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
balanceBefore: (f = msg.getBalanceBefore()) && google_type_money_pb.Money.toObject(includeInstance, f),
balanceAfter: (f = msg.getBalanceAfter()) && google_type_money_pb.Money.toObject(includeInstance, f),
description: jspb.Message.getFieldWithDefault(msg, 7, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
taskId: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
stripePaymentIntentId: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
metadata: (f = msg.getMetadata()) && proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.toObject(includeInstance, f),
estimatedAmount: (f = msg.getEstimatedAmount()) && google_type_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.BillingTransaction;
  return proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 3:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.billing.TransactionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 5:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setBalanceBefore(value);
      break;
    case 6:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setBalanceAfter(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setStripePaymentIntentId(value);
      break;
    case 11:
      var value = new proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 12:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setEstimatedAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getBalanceBefore();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getBalanceAfter();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.serializeBinaryToWriter
    );
  }
  f = message.getEstimatedAmount();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional string transaction_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.getTransactionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.setTransactionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_email = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional TransactionType type = 3;
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TransactionType}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.getType = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.billing.TransactionType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TransactionType} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.type.Money amount = 4;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.getAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 4));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.type.Money balance_before = 5;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.getBalanceBefore = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 5));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.setBalanceBefore = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.clearBalanceBefore = function() {
  return this.setBalanceBefore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.hasBalanceBefore = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.type.Money balance_after = 6;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.getBalanceAfter = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 6));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.setBalanceAfter = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.clearBalanceAfter = function() {
  return this.setBalanceAfter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.hasBalanceAfter = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string task_id = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.setTaskId = function(value) {
  return jspb.Message.setOneofField(this, 9, proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.clearTaskId = function() {
  return jspb.Message.setOneofField(this, 9, proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.hasTaskId = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string stripe_payment_intent_id = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.getStripePaymentIntentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.setStripePaymentIntentId = function(value) {
  return jspb.Message.setOneofField(this, 10, proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.clearStripePaymentIntentId = function() {
  return jspb.Message.setOneofField(this, 10, proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.hasStripePaymentIntentId = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional TransactionMetadata metadata = 11;
 * @return {?proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.getMetadata = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata, 11));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.type.Money estimated_amount = 12;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.getEstimatedAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 12));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.setEstimatedAmount = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.clearEstimatedAmount = function() {
  return this.setEstimatedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.prototype.hasEstimatedAmount = function() {
  return jspb.Message.getField(this, 12) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.oneofGroups_ = [[2,5]];

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.SpecificMetadataCase = {
  SPECIFIC_METADATA_NOT_SET: 0,
  TASK_COMPLETION: 2,
  AUTHORIZATION_HOLD: 5
};

/**
 * @return {proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.SpecificMetadataCase}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.getSpecificMetadataCase = function() {
  return /** @type {proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.SpecificMetadataCase} */(jspb.Message.computeOneofCase(this, proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
source: jspb.Message.getFieldWithDefault(msg, 1, ""),
notes: jspb.Message.getFieldWithDefault(msg, 3, ""),
operatorPrincipal: jspb.Message.getFieldWithDefault(msg, 4, ""),
taskCompletion: (f = msg.getTaskCompletion()) && proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.toObject(includeInstance, f),
authorizationHold: (f = msg.getAuthorizationHold()) && proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata;
  return proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperatorPrincipal(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.deserializeBinaryFromReader);
      msg.setTaskCompletion(value);
      break;
    case 5:
      var value = new proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.deserializeBinaryFromReader);
      msg.setAuthorizationHold(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOperatorPrincipal();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTaskCompletion();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.serializeBinaryToWriter
    );
  }
  f = message.getAuthorizationHold();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional string source = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string notes = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string operator_principal = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.getOperatorPrincipal = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.setOperatorPrincipal = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional TaskCompletionTransactionMetadata task_completion = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.getTaskCompletion = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.setTaskCompletion = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.clearTaskCompletion = function() {
  return this.setTaskCompletion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.hasTaskCompletion = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AuthorizationHoldTransactionMetadata authorization_hold = 5;
 * @return {?proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.getAuthorizationHold = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata, 5));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.setAuthorizationHold = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.clearAuthorizationHold = function() {
  return this.setAuthorizationHold(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionMetadata.prototype.hasAuthorizationHold = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
taskType: jspb.Message.getFieldWithDefault(msg, 2, ""),
authorizedAmount: (f = msg.getAuthorizedAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
capturedAmount: (f = msg.getCapturedAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
releasedAmount: (f = msg.getReleasedAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
availableBalanceAfter: (f = msg.getAvailableBalanceAfter()) && google_type_money_pb.Money.toObject(includeInstance, f),
state: jspb.Message.getFieldWithDefault(msg, 7, 0),
closeReason: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata;
  return proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskType(value);
      break;
    case 3:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setAuthorizedAmount(value);
      break;
    case 4:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setCapturedAmount(value);
      break;
    case 5:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setReleasedAmount(value);
      break;
    case 6:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setAvailableBalanceAfter(value);
      break;
    case 7:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCloseReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAuthorizedAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getCapturedAmount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getReleasedAmount();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getAvailableBalanceAfter();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getCloseReason();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string task_type = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.getTaskType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.setTaskType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.type.Money authorized_amount = 3;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.getAuthorizedAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 3));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.setAuthorizedAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.clearAuthorizedAmount = function() {
  return this.setAuthorizedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.hasAuthorizedAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.type.Money captured_amount = 4;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.getCapturedAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 4));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.setCapturedAmount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.clearCapturedAmount = function() {
  return this.setCapturedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.hasCapturedAmount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.type.Money released_amount = 5;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.getReleasedAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 5));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.setReleasedAmount = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.clearReleasedAmount = function() {
  return this.setReleasedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.hasReleasedAmount = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.type.Money available_balance_after = 6;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.getAvailableBalanceAfter = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 6));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.setAvailableBalanceAfter = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.clearAvailableBalanceAfter = function() {
  return this.setAvailableBalanceAfter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.hasAvailableBalanceAfter = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional BillingHoldState state = 7;
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.getState = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingHoldState} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string close_reason = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.getCloseReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.AuthorizationHoldTransactionMetadata.prototype.setCloseReason = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
taskType: jspb.Message.getFieldWithDefault(msg, 2, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
pageId: jspb.Message.getFieldWithDefault(msg, 4, 0),
filename: jspb.Message.getFieldWithDefault(msg, 5, ""),
pageTitle: jspb.Message.getFieldWithDefault(msg, 6, ""),
authorizedAmount: (f = msg.getAuthorizedAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
actualAmount: (f = msg.getActualAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
unbilledAmount: (f = msg.getUnbilledAmount()) && google_type_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata;
  return proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageTitle(value);
      break;
    case 7:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setAuthorizedAmount(value);
      break;
    case 8:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setActualAmount(value);
      break;
    case 9:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setUnbilledAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPageTitle();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAuthorizedAmount();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getActualAmount();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getUnbilledAmount();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string task_type = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.getTaskType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.setTaskType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page_id = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.getPageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.setPageId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string filename = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string page_title = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.getPageTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.setPageTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.type.Money authorized_amount = 7;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.getAuthorizedAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 7));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.setAuthorizedAmount = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.clearAuthorizedAmount = function() {
  return this.setAuthorizedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.hasAuthorizedAmount = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.type.Money actual_amount = 8;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.getActualAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 8));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.setActualAmount = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.clearActualAmount = function() {
  return this.setActualAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.hasActualAmount = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.type.Money unbilled_amount = 9;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.getUnbilledAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 9));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.setUnbilledAmount = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.clearUnbilledAmount = function() {
  return this.setUnbilledAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.prototype.hasUnbilledAmount = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest;
  return proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
profile: (f = msg.getProfile()) && proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse;
  return proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.deserializeBinaryFromReader);
      msg.setProfile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserBillingProfile profile = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile}
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.prototype.getProfile = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.billing.UserBillingProfile|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.prototype.setProfile = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.prototype.clearProfile = function() {
  return this.setProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.GetUserBillingProfileResponse.prototype.hasProfile = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
amount: (f = msg.getAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
paymentMethodId: jspb.Message.getFieldWithDefault(msg, 2, ""),
returnUrl: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest;
  return proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethodId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReturnUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getPaymentMethodId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReturnUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional google.type.Money amount = 1;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.prototype.getAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 1));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string payment_method_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.prototype.getPaymentMethodId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.prototype.setPaymentMethodId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string return_url = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.prototype.getReturnUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceRequest.prototype.setReturnUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
stripePaymentIntentId: jspb.Message.getFieldWithDefault(msg, 3, ""),
clientSecret: jspb.Message.getFieldWithDefault(msg, 4, ""),
transaction: (f = msg.getTransaction()) && proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.toObject(includeInstance, f),
checkoutUrl: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse;
  return proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStripePaymentIntentId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientSecret(value);
      break;
    case 5:
      var value = new proto.org.codetricks.construction.code.assistant.billing.BillingTransaction;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.deserializeBinaryFromReader);
      msg.setTransaction(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckoutUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStripePaymentIntentId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getClientSecret();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTransaction();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.serializeBinaryToWriter
    );
  }
  f = message.getCheckoutUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string stripe_payment_intent_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.getStripePaymentIntentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.setStripePaymentIntentId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string client_secret = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.getClientSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.setClientSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional BillingTransaction transaction = 5;
 * @return {?proto.org.codetricks.construction.code.assistant.billing.BillingTransaction}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.getTransaction = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.BillingTransaction, 5));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.billing.BillingTransaction|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.setTransaction = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.clearTransaction = function() {
  return this.setTransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.hasTransaction = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string checkout_url = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.getCheckoutUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TopUpBalanceResponse.prototype.setCheckoutUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
limit: jspb.Message.getFieldWithDefault(msg, 1, 0),
pageToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
typeFilter: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest;
  return proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    case 3:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.billing.TransactionType} */ (reader.readEnum());
      msg.setTypeFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTypeFilter();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int32 limit = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string page_token = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional TransactionType type_filter = 3;
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TransactionType}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.prototype.getTypeFilter = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.billing.TransactionType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TransactionType} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryRequest.prototype.setTypeFilter = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
transactionsList: jspb.Message.toObjectList(msg.getTransactionsList(),
    proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.toObject, includeInstance),
nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse;
  return proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.billing.BillingTransaction;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.deserializeBinaryFromReader);
      msg.addTransactions(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated BillingTransaction transactions = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction>}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.prototype.getTransactionsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.BillingTransaction, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction>} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.prototype.setTransactionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.prototype.addTransactions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.billing.BillingTransaction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.prototype.clearTransactionsList = function() {
  return this.setTransactionsList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetTransactionHistoryResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
limit: jspb.Message.getFieldWithDefault(msg, 1, 0),
pageToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
includeCollaborators: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest;
  return proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeCollaborators(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIncludeCollaborators();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int32 limit = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string page_token = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool include_collaborators = 3;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.prototype.getIncludeCollaborators = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryRequest.prototype.setIncludeCollaborators = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
projectExpensesList: jspb.Message.toObjectList(msg.getProjectExpensesList(),
    proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.toObject, includeInstance),
nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalExpenses: (f = msg.getTotalExpenses()) && google_type_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse;
  return proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.deserializeBinaryFromReader);
      msg.addProjectExpenses(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    case 3:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalExpenses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectExpensesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalExpenses();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ProjectExpenseSummary project_expenses = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary>}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.prototype.getProjectExpensesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary>} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.prototype.setProjectExpensesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.prototype.addProjectExpenses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.prototype.clearProjectExpensesList = function() {
  return this.setProjectExpensesList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.type.Money total_expenses = 3;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.prototype.getTotalExpenses = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 3));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.prototype.setTotalExpenses = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.prototype.clearTotalExpenses = function() {
  return this.setTotalExpenses(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.GetExpenseHistoryResponse.prototype.hasTotalExpenses = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
projectName: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalCost: (f = msg.getTotalCost()) && google_type_money_pb.Money.toObject(includeInstance, f),
taskCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
recentTransactionsList: jspb.Message.toObjectList(msg.getRecentTransactionsList(),
    proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.toObject, includeInstance),
taskTypeBreakdownList: jspb.Message.toObjectList(msg.getTaskTypeBreakdownList(),
    proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.toObject, includeInstance),
fileCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
pageCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
avgDurationSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
durationStdDev: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
minCostPerTask: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
maxCostPerTask: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
minDurationSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
maxDurationSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary;
  return proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectName(value);
      break;
    case 3:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalCost(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTaskCount(value);
      break;
    case 5:
      var value = new proto.org.codetricks.construction.code.assistant.billing.BillingTransaction;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.deserializeBinaryFromReader);
      msg.addRecentTransactions(value);
      break;
    case 6:
      var value = new proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.deserializeBinaryFromReader);
      msg.addTaskTypeBreakdown(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFileCount(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageCount(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgDurationSeconds(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDurationStdDev(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinCostPerTask(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxCostPerTask(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinDurationSeconds(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxDurationSeconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalCost();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getTaskCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getRecentTransactionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.serializeBinaryToWriter
    );
  }
  f = message.getTaskTypeBreakdownList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.serializeBinaryToWriter
    );
  }
  f = message.getFileCount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPageCount();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getAvgDurationSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getDurationStdDev();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getMinCostPerTask();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getMaxCostPerTask();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getMinDurationSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getMaxDurationSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_name = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getProjectName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setProjectName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.type.Money total_cost = 3;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getTotalCost = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 3));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setTotalCost = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.clearTotalCost = function() {
  return this.setTotalCost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.hasTotalCost = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 task_count = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getTaskCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setTaskCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated BillingTransaction recent_transactions = 5;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction>}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getRecentTransactionsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.BillingTransaction, 5));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction>} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setRecentTransactionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.billing.BillingTransaction}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.addRecentTransactions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.org.codetricks.construction.code.assistant.billing.BillingTransaction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.clearRecentTransactionsList = function() {
  return this.setRecentTransactionsList([]);
};


/**
 * repeated TaskTypeExpenseSummary task_type_breakdown = 6;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary>}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getTaskTypeBreakdownList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary, 6));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary>} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setTaskTypeBreakdownList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.addTaskTypeBreakdown = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.clearTaskTypeBreakdownList = function() {
  return this.setTaskTypeBreakdownList([]);
};


/**
 * optional int32 file_count = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getFileCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setFileCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 page_count = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional double avg_duration_seconds = 9;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getAvgDurationSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setAvgDurationSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double duration_std_dev = 10;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getDurationStdDev = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setDurationStdDev = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double min_cost_per_task = 11;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getMinCostPerTask = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setMinCostPerTask = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double max_cost_per_task = 12;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getMaxCostPerTask = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setMaxCostPerTask = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional double min_duration_seconds = 13;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getMinDurationSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setMinDurationSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional double max_duration_seconds = 14;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.getMaxDurationSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseSummary.prototype.setMaxDurationSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.repeatedFields_ = [16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
taskType: jspb.Message.getFieldWithDefault(msg, 1, ""),
taskCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
totalCost: (f = msg.getTotalCost()) && google_type_money_pb.Money.toObject(includeInstance, f),
fileCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
pageCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
avgCostPerTask: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
costStdDev: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
avgDurationSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
durationStdDev: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
minCostPerTask: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
maxCostPerTask: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
minDurationSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
maxDurationSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
lastActivityAt: (f = msg.getLastActivityAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
durationSampleCount: jspb.Message.getFieldWithDefault(msg, 15, 0),
collaboratorContributionsList: jspb.Message.toObjectList(msg.getCollaboratorContributionsList(),
    proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary;
  return proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTaskCount(value);
      break;
    case 3:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalCost(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFileCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgCostPerTask(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCostStdDev(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgDurationSeconds(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDurationStdDev(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinCostPerTask(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxCostPerTask(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinDurationSeconds(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxDurationSeconds(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastActivityAt(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDurationSampleCount(value);
      break;
    case 16:
      var value = new proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.deserializeBinaryFromReader);
      msg.addCollaboratorContributions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalCost();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getFileCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPageCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getAvgCostPerTask();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getCostStdDev();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getAvgDurationSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getDurationStdDev();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getMinCostPerTask();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getMaxCostPerTask();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getMinDurationSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getMaxDurationSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getLastActivityAt();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDurationSampleCount();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getCollaboratorContributionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.serializeBinaryToWriter
    );
  }
};


/**
 * optional string task_type = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getTaskType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setTaskType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 task_count = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getTaskCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setTaskCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.type.Money total_cost = 3;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getTotalCost = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 3));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setTotalCost = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.clearTotalCost = function() {
  return this.setTotalCost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.hasTotalCost = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 file_count = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getFileCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setFileCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 page_count = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional double avg_cost_per_task = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getAvgCostPerTask = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setAvgCostPerTask = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double cost_std_dev = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getCostStdDev = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setCostStdDev = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double avg_duration_seconds = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getAvgDurationSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setAvgDurationSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double duration_std_dev = 9;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getDurationStdDev = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setDurationStdDev = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double min_cost_per_task = 10;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getMinCostPerTask = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setMinCostPerTask = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double max_cost_per_task = 11;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getMaxCostPerTask = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setMaxCostPerTask = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double min_duration_seconds = 12;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getMinDurationSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setMinDurationSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional double max_duration_seconds = 13;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getMaxDurationSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setMaxDurationSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional google.protobuf.Timestamp last_activity_at = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getLastActivityAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setLastActivityAt = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.clearLastActivityAt = function() {
  return this.setLastActivityAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.hasLastActivityAt = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional int32 duration_sample_count = 15;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getDurationSampleCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setDurationSampleCount = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * repeated CollaboratorContribution collaborator_contributions = 16;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution>}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.getCollaboratorContributionsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution, 16));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution>} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.setCollaboratorContributionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution}
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.addCollaboratorContributions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.TaskTypeExpenseSummary.prototype.clearCollaboratorContributionsList = function() {
  return this.setCollaboratorContributionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.toObject = function(includeInstance, msg) {
  var f, obj = {
userEmail: jspb.Message.getFieldWithDefault(msg, 1, ""),
displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
taskCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalCost: (f = msg.getTotalCost()) && google_type_money_pb.Money.toObject(includeInstance, f),
fileCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
pageCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
avgCostPerTask: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
costStdDev: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
avgDurationSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
durationStdDev: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
lastActivityAt: (f = msg.getLastActivityAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
photoUrl: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution;
  return proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTaskCount(value);
      break;
    case 4:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalCost(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFileCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageCount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgCostPerTask(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCostStdDev(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgDurationSeconds(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDurationStdDev(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastActivityAt(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhotoUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTaskCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalCost();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getFileCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPageCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getAvgCostPerTask();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getCostStdDev();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getAvgDurationSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getDurationStdDev();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getLastActivityAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPhotoUrl();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string user_email = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 task_count = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.getTaskCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.setTaskCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.type.Money total_cost = 4;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.getTotalCost = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 4));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.setTotalCost = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.clearTotalCost = function() {
  return this.setTotalCost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.hasTotalCost = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 file_count = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.getFileCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.setFileCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 page_count = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.getPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.setPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional double avg_cost_per_task = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.getAvgCostPerTask = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.setAvgCostPerTask = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double cost_std_dev = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.getCostStdDev = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.setCostStdDev = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double avg_duration_seconds = 9;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.getAvgDurationSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.setAvgDurationSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double duration_std_dev = 10;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.getDurationStdDev = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.setDurationStdDev = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp last_activity_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.getLastActivityAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.setLastActivityAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.clearLastActivityAt = function() {
  return this.setLastActivityAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.hasLastActivityAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string photo_url = 12;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.getPhotoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CollaboratorContribution.prototype.setPhotoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
pageToken: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest;
  return proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string page_token = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
expensesList: jspb.Message.toObjectList(msg.getExpensesList(),
    proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.toObject, includeInstance),
nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalProjectCost: (f = msg.getTotalProjectCost()) && google_type_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse;
  return proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.deserializeBinaryFromReader);
      msg.addExpenses(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    case 3:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalProjectCost(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExpensesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalProjectCost();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ProjectExpenseEntry expenses = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry>}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.prototype.getExpensesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry>} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.prototype.setExpensesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.prototype.addExpenses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.prototype.clearExpensesList = function() {
  return this.setExpensesList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.type.Money total_project_cost = 3;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.prototype.getTotalProjectCost = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 3));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.prototype.setTotalProjectCost = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.prototype.clearTotalProjectCost = function() {
  return this.setTotalProjectCost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.GetProjectExpenseHistoryResponse.prototype.hasTotalProjectCost = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
userEmail: jspb.Message.getFieldWithDefault(msg, 1, ""),
transaction: (f = msg.getTransaction()) && proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.toObject(includeInstance, f),
taskDetails: (f = msg.getTaskDetails()) && proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry;
  return proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.billing.BillingTransaction;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.deserializeBinaryFromReader);
      msg.setTransaction(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.deserializeBinaryFromReader);
      msg.setTaskDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTransaction();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.serializeBinaryToWriter
    );
  }
  f = message.getTaskDetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_email = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional BillingTransaction transaction = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.billing.BillingTransaction}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.prototype.getTransaction = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.BillingTransaction, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.billing.BillingTransaction|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.prototype.setTransaction = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.prototype.clearTransaction = function() {
  return this.setTransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.prototype.hasTransaction = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TaskCompletionTransactionMetadata task_details = 3;
 * @return {?proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.prototype.getTaskDetails = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata, 3));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.billing.TaskCompletionTransactionMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.prototype.setTaskDetails = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.prototype.clearTaskDetails = function() {
  return this.setTaskDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.ProjectExpenseEntry.prototype.hasTaskDetails = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userEmail: jspb.Message.getFieldWithDefault(msg, 1, ""),
estimatedCost: (f = msg.getEstimatedCost()) && google_type_money_pb.Money.toObject(includeInstance, f),
taskType: jspb.Message.getFieldWithDefault(msg, 3, ""),
taskCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
operationId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest;
  return proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 2:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setEstimatedCost(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTaskCount(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEstimatedCost();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getTaskType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTaskCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getOperationId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string user_email = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.type.Money estimated_cost = 2;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.getEstimatedCost = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 2));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.setEstimatedCost = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.clearEstimatedCost = function() {
  return this.setEstimatedCost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.hasEstimatedCost = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string task_type = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.getTaskType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.setTaskType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 task_count = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.getTaskCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.setTaskCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string operation_id = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.getOperationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceRequest.prototype.setOperationId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
hasSufficientBalance: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
currentBalance: (f = msg.getCurrentBalance()) && google_type_money_pb.Money.toObject(includeInstance, f),
requiredAmount: (f = msg.getRequiredAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
shortfall: (f = msg.getShortfall()) && google_type_money_pb.Money.toObject(includeInstance, f),
heldBalance: (f = msg.getHeldBalance()) && google_type_money_pb.Money.toObject(includeInstance, f),
ledgerBalance: (f = msg.getLedgerBalance()) && google_type_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse;
  return proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasSufficientBalance(value);
      break;
    case 2:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setCurrentBalance(value);
      break;
    case 3:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setRequiredAmount(value);
      break;
    case 4:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setShortfall(value);
      break;
    case 5:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setHeldBalance(value);
      break;
    case 6:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setLedgerBalance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasSufficientBalance();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCurrentBalance();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getRequiredAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getShortfall();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getHeldBalance();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getLedgerBalance();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool has_sufficient_balance = 1;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.getHasSufficientBalance = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.setHasSufficientBalance = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional google.type.Money current_balance = 2;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.getCurrentBalance = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 2));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.setCurrentBalance = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.clearCurrentBalance = function() {
  return this.setCurrentBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.hasCurrentBalance = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.type.Money required_amount = 3;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.getRequiredAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 3));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.setRequiredAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.clearRequiredAmount = function() {
  return this.setRequiredAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.hasRequiredAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.type.Money shortfall = 4;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.getShortfall = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 4));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.setShortfall = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.clearShortfall = function() {
  return this.setShortfall(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.hasShortfall = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.type.Money held_balance = 5;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.getHeldBalance = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 5));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.setHeldBalance = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.clearHeldBalance = function() {
  return this.setHeldBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.hasHeldBalance = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.type.Money ledger_balance = 6;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.getLedgerBalance = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 6));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.setLedgerBalance = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.clearLedgerBalance = function() {
  return this.setLedgerBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.CheckSufficientBalanceResponse.prototype.hasLedgerBalance = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userEmail: jspb.Message.getFieldWithDefault(msg, 1, ""),
costAmount: (f = msg.getCostAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
taskId: jspb.Message.getFieldWithDefault(msg, 3, ""),
projectId: jspb.Message.getFieldWithDefault(msg, 4, ""),
taskType: jspb.Message.getFieldWithDefault(msg, 5, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 6, ""),
pageId: jspb.Message.getFieldWithDefault(msg, 7, 0),
filename: jspb.Message.getFieldWithDefault(msg, 8, ""),
pageTitle: jspb.Message.getFieldWithDefault(msg, 9, ""),
holdId: jspb.Message.getFieldWithDefault(msg, 10, ""),
terminalState: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest;
  return proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 2:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setCostAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageTitle(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTerminalState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCostAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTaskType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPageId();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPageTitle();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getHoldId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTerminalState();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string user_email = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.type.Money cost_amount = 2;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.getCostAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 2));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.setCostAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.clearCostAmount = function() {
  return this.setCostAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.hasCostAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string task_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string project_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string task_type = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.getTaskType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.setTaskType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string file_id = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 page_id = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.getPageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.setPageId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string filename = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string page_title = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.getPageTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.setPageTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string hold_id = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.getHoldId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.setHoldId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string terminal_state = 11;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.getTerminalState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostRequest.prototype.setTerminalState = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
transaction: (f = msg.getTransaction()) && proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.toObject(includeInstance, f),
newBalance: (f = msg.getNewBalance()) && google_type_money_pb.Money.toObject(includeInstance, f),
capturedAmount: (f = msg.getCapturedAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
unbilledAmount: (f = msg.getUnbilledAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
releasedHoldAmount: (f = msg.getReleasedHoldAmount()) && google_type_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse;
  return proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.billing.BillingTransaction;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.deserializeBinaryFromReader);
      msg.setTransaction(value);
      break;
    case 4:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setNewBalance(value);
      break;
    case 5:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setCapturedAmount(value);
      break;
    case 6:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setUnbilledAmount(value);
      break;
    case 7:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setReleasedHoldAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTransaction();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.billing.BillingTransaction.serializeBinaryToWriter
    );
  }
  f = message.getNewBalance();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getCapturedAmount();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getUnbilledAmount();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getReleasedHoldAmount();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional BillingTransaction transaction = 3;
 * @return {?proto.org.codetricks.construction.code.assistant.billing.BillingTransaction}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.getTransaction = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.billing.BillingTransaction} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.BillingTransaction, 3));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.billing.BillingTransaction|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.setTransaction = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.clearTransaction = function() {
  return this.setTransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.hasTransaction = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.type.Money new_balance = 4;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.getNewBalance = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 4));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.setNewBalance = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.clearNewBalance = function() {
  return this.setNewBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.hasNewBalance = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.type.Money captured_amount = 5;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.getCapturedAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 5));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.setCapturedAmount = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.clearCapturedAmount = function() {
  return this.setCapturedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.hasCapturedAmount = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.type.Money unbilled_amount = 6;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.getUnbilledAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 6));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.setUnbilledAmount = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.clearUnbilledAmount = function() {
  return this.setUnbilledAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.hasUnbilledAmount = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.type.Money released_hold_amount = 7;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.getReleasedHoldAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 7));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.setReleasedHoldAmount = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.clearReleasedHoldAmount = function() {
  return this.setReleasedHoldAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.DeductTaskCostResponse.prototype.hasReleasedHoldAmount = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
reason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest;
  return proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
released: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
hold: (f = msg.getHold()) && proto.org.codetricks.construction.code.assistant.billing.BillingHold.toObject(includeInstance, f),
availableBalance: (f = msg.getAvailableBalance()) && google_type_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse;
  return proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReleased(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.billing.BillingHold;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.billing.BillingHold.deserializeBinaryFromReader);
      msg.setHold(value);
      break;
    case 3:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setAvailableBalance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReleased();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getHold();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.billing.BillingHold.serializeBinaryToWriter
    );
  }
  f = message.getAvailableBalance();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool released = 1;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.prototype.getReleased = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.prototype.setReleased = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional BillingHold hold = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.billing.BillingHold}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.prototype.getHold = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.billing.BillingHold} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.billing.BillingHold, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.billing.BillingHold|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.prototype.setHold = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.prototype.clearHold = function() {
  return this.setHold(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.prototype.hasHold = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.type.Money available_balance = 3;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.prototype.getAvailableBalance = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 3));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.prototype.setAvailableBalance = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.prototype.clearAvailableBalance = function() {
  return this.setAvailableBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.billing.ReleaseTaskCostHoldResponse.prototype.hasAvailableBalance = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.toObject = function(includeInstance, msg) {
  var f, obj = {
eventType: jspb.Message.getFieldWithDefault(msg, 1, ""),
paymentIntentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
amountCents: jspb.Message.getFieldWithDefault(msg, 3, 0),
currency: jspb.Message.getFieldWithDefault(msg, 4, ""),
userEmail: jspb.Message.getFieldWithDefault(msg, 5, ""),
status: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData}
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData;
  return proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData}
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentIntentId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountCents(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentIntentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string event_type = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.getEventType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.setEventType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string payment_intent_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.getPaymentIntentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.setPaymentIntentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 amount_cents = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.getAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.setAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string user_email = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData} returns this
 */
proto.org.codetricks.construction.code.assistant.billing.StripeWebhookEventData.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldState = {
  BILLING_HOLD_STATE_UNSPECIFIED: 0,
  OPEN: 1,
  CAPTURED: 2,
  RELEASED: 3,
  SETTLING: 4
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldChildState = {
  BILLING_HOLD_CHILD_STATE_UNSPECIFIED: 0,
  REGISTERED: 1,
  SUCCEEDED: 2,
  FAILED: 3,
  CANCELLED: 4
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.billing.BillingHoldAuditEventType = {
  BILLING_HOLD_AUDIT_EVENT_TYPE_UNSPECIFIED: 0,
  HOLD_PLACED: 1,
  CHILD_REGISTERED: 2,
  CHILD_SUCCEEDED: 3,
  CHILD_FAILED: 4,
  CHILD_CANCELLED: 5,
  SETTLEMENT_STARTED: 6,
  HOLD_SETTLED: 7,
  HOLD_RELEASED: 8,
  HOLD_EXPIRED: 9,
  LATE_TERMINAL_IGNORED: 10,
  SETTLEMENT_RECONCILED: 11
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.billing.SubscriptionTier = {
  SUBSCRIPTION_TIER_UNSPECIFIED: 0,
  TRIAL: 1,
  BASIC: 2,
  PROFESSIONAL: 3,
  ENTERPRISE: 4
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.billing.TransactionType = {
  TRANSACTION_TYPE_UNSPECIFIED: 0,
  CREDIT: 1,
  DEBIT: 2,
  REFUND: 3,
  ADJUSTMENT: 4,
  COMPLIMENTARY: 5,
  NON_CHARGED: 6,
  AUTHORIZATION_HOLD: 7,
  AUTHORIZATION_RELEASE: 8,
  AUTHORIZATION_SETTLEMENT: 9
};

goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.billing);
